<template>
	<TopTab />
	<Banner />
	<QuickRoute :news="newsList[0]" />
	<SearchBar  @search="id => router.push('/assets-detail?id=' + id)" />
	<Title title="行业资讯" url="/news?type=95" />
	<ul>
		<li v-for="item in newsList" :key="item.id">
			<NewsItem :data="item" :url="'/news-detail?id=' + item.id" />
		</li>
	</ul>
	<Title title="遇见文物" url="/collection" />
	<div class="swiper_container">
		<swiper :loop="true" :slidesPerView="3" :spaceBetween="0" :modules="modules" class="mySwiper" :autoplay="{
			delay: 2500,
		}" :show-indicators="true" :navigation="true">
			<swiper-slide v-for="item in modelList">
				<div class="swiper_item" @click="router.push('/assets-detail?id=' + item.id)">
					<img :src="item.picUrl?.split(';')[0]" />
					<p>{{ item.name }}</p>
				</div>
			</swiper-slide>
		</swiper>
	</div>
	<Title title="鉴宝赏析" url="/art" />
	<ul class="list2">
		<li v-for="item in newsList2" :key="item.id" @click="router.push('/art-detail?id=' + item.id)">
			<NewsItem2 :data="item" />
		</li>
	</ul>
	<Title title="公司公告" url="/news?type=94" />
	<ul class="list3">
		<li v-for="item in newsList3" :key="item.id" @click="router.push('/news-detail?id=' + item.id)">
			<Board :data="item" />
		</li>
	</ul>
	<FooterBar />
	<van-floating-bubble :icon="require('@/assets/imgs/icon77.png')" style="background-color: rgba(114, 111, 249, 0.5);" @click="showDialogClick" />
	<van-dialog v-model:show="showDialog" title="资讯服务" show-cancel-button>
		<div class="contact">
			<p>资讯热线： 400-0788-232</p>
			<p>客服QQ：</p>
			<img src="https://image.dfshuke.com/2026/05/02/a7a495a54d0a4297855a1c3721dbbd3a%E5%BE%AE%E4%BF%A1%E5%85%AC%E4%BC%97%E5%8F%B7.jpg" />
		</div>
	</van-dialog>
</template>

<script setup>
import TopTab from '@/views/front/components/TopTab.vue'
import { onMounted, computed, ref, watch, reactive } from 'vue'
import { useRouter } from 'vue-router'
import FooterBar from '@/views/front/components/FooterBar.vue'
import NewsItem from '@/views/front/components/NewsItem.vue'
import NewsItem2 from '@/views/front/components/NewsItem2.vue'
import { useStore } from 'vuex'
import QuickRoute from './QuickRoute.vue'
import Banner from './Banner.vue'
import Title from '../components/Title.vue'
import { http, WEBSITE } from '@/request/http.js'
import axios from 'axios'
import { Swiper, SwiperSlide } from 'swiper/vue';
import SearchBar from './SearchBar.vue'
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { showNotify } from 'vant'
import Board from './Board.vue'

const modules = [Autoplay, Pagination, Navigation]
const router = useRouter()
const store = useStore()
const newsList = ref([])
// 行业资讯
function fetchNewsList() {
	axios.post(WEBSITE + '/pro-api/pc/content/getContentList', { "limit": 2, "page": 1, "sortType": 1, "status": 1, "websiteId": 10000001, "columnId": 95 }).then(res => {
		newsList.value = res.data.rows
	})
}
const modelList = ref([])
// 遇见文物
function fetchModelList() {
	http.get('/app-api/product/spu/page').then(res => {
		modelList.value = res.list
	})
}
const newsList2 = ref([])
// 鉴宝赏析
function fetchNewsList2() {
	http.get('/app-api/promotion/article/page?returnType=2&pageNo=1&pageSize=2&sortType=2&categoryId=3').then(res => {
		newsList2.value = res.list
	}).catch(err => {
		showNotify('服务器连接错误')
	})
}
const newsList3 = ref([])
// 公司公告
function fetchNewsList3() {
	axios.post('https://www.dfshuke.com/pro-api/pc/content/getContentList', { "limit": 9, "page": 1, "sortType": 1, "status": 1, "websiteId": 10000001, "columnId": 94 }).then(res => {
		newsList3.value = res.data.rows
	}).catch(err => {
		showNotify('服务器连接错误')
	})
}
onMounted(() => {
	fetchNewsList()
	fetchModelList()
	fetchNewsList2()
	fetchNewsList3()
})

const showDialog = ref(false)
const showDialogClick = () => {
	showDialog.value = true
}


</script>

<style scoped lang="scss">
.swiper_container {

	padding: 10rem 0;

	.mySwiper {
		height: 100%;
		position: relative;
		padding: 20rem 0;

		::v-deep(.swiper-button-prev) {
			background-color: #AAA9FB;
			color: #FFF;
			width: 20rem;
			height: 20rem;
			padding: 5rem;
			position: absolute;
			left: calc(50vw - 110rem);
			top: 204rem;
		}

		::v-deep(.swiper-button-next) {
			background-color: #AAA9FB;
			color: #FFF;
			width: 20rem;
			height: 20rem;
			padding: 5rem;
			position: absolute;
			left: calc(50vw + 90rem);
			top: 204rem;
		}

		.swiper-slide {
			transform: scale(0.7, 0.8);
			transition: transform 0.3s ease-in-out;
		}

		.swiper-slide-next {
			transform: scale(1.1);

			.swiper_item {
				p {
					opacity: 1;
				}
			}

		}

		.swiper_item {
			height: 170rem;
			background-color: #CECECE;

			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}

			p {
				width: 100%;
				background-color: rgba(0, 0, 0, 0.5);
				left: 0;
				color: #FFF;
				font-size: 14rem;
				padding: 5rem 0;
				text-align: center;
				position: absolute;
				bottom: 0;
				opacity: 0;
				transition: opacity 0.3s ease-in-out;
			}
		}
	}
}

.list2 {
	display: flex;
	padding: 15rem;
	justify-content: space-between;

	>li {
		width: calc(50% - 7rem);
		// border-bottom: 1px solid #726FF9;
	}
}

.list3 {
	margin: 0 15rem;
	padding-bottom: 20rem;

	li {
		margin: 10rem 0;
	}
}
.contact{
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-top: 20rem;
	img{
		width: 200rem;
	}
	p{
		width: 200rem;
		height: 30rem;
	}
}
</style>
